import React, { useState } from "react";
import styles from "./styles.module.css";
import ReactModal from "react-modal";
import { Button } from "@/components/Button";
import { Badge } from "@/components/Badge";
import Coin from "@/assets/capybara-images/coin.svg?react";
import ModalCloser from "@/assets/capybara-images/modalCloser.svg?react";
import { renderTextWithLineBreaks } from "@/utils/renderTextWithLineBreaks";
import { observer } from "mobx-react-lite";

interface BoostModalProps {
  title: string;
  text: string;
  onClose?: () => void;
  onAction?: () => void;
  modalTitleColor: string;
  modalIcon: string;
  modalWallpaper: string;
  isOpen?: boolean;
  hint?: string;
  cost?: number | null;
  level?: number | null;
  amount?: number | null;
  availableAmount?: number | null;
  info?: string | null;
}

export const BoostModal: React.FC<BoostModalProps> = observer(
  ({
    isOpen = false,
    onClose,
    onAction,
    title,
    modalTitleColor,
    modalIcon,
    modalWallpaper,
    text,
    hint,
    cost,
    level,
    amount,
    availableAmount,
    info,
  }) => {
    const [closing, setClosing] = useState(false);

    const handleClose = () => {
      setClosing(true);
      setTimeout(() => {
        setClosing(false);
        onClose && onClose();
      }, 300);
    };

    const handleAction = () => {
      setClosing(true);
      setTimeout(() => {
        setClosing(false);
        console.log("onAction");
        onAction && onAction();
      }, 300);
    };

    return (
      <ReactModal
        ariaHideApp={false}
        overlayClassName={styles.modalOverlay}
        shouldCloseOnOverlayClick={true}
        onRequestClose={handleClose}
        className={`${styles.modalContainer} ${
          closing ? styles.modalClose : ""
        }`}
        isOpen={isOpen}
      >
        <div className={styles.modalContentWrapper}>
          <div
            className={styles.modalContent}
            style={{
              backgroundImage: `url(${modalWallpaper})`,
            }}
          >
            <ModalCloser
              className={styles.modalCloser}
              onClick={handleClose}
            ></ModalCloser>
            <img className={styles.modalImg} src={modalIcon} alt="icon" />
            <div className={styles.textContainer}>
              <h2
                style={{
                  color: modalTitleColor,
                }}
                className={styles.modalTitle}
              >
                {renderTextWithLineBreaks(title)}
              </h2>
              <div>
                <div className={styles.modalText}>{text}</div>
                <div className={styles.modalText}>{hint}</div>
              </div>
            </div>
            <div className={styles.boostBlockCostContainer}>
              {cost && (
                <Badge color="blue">
                  {cost.toLocaleString("en-US")}
                  <Coin width={16} height={16} />
                </Badge>
              )}
              {level !== null && level !== undefined && level >= 0 && (
                <div className={styles.level}>
                  <p>{`${level} lvl`} </p>
                </div>
              )}
              {amount && (
                <p className={styles.amount}>
                  {`${availableAmount} of ${availableAmount} available`}
                </p>
              )}
              <Badge color="lightblue" visible={Boolean(info)}>
                {info}
              </Badge>
            </div>
            <Button
              onClick={handleAction}
              label="Get Booster"
              styleType="primary"
              block={true}
            ></Button>
          </div>
        </div>
      </ReactModal>
    );
  }
);
